import { useAuthStore } from "~/store/auth/auth.store";
import { useCompaniesStore } from "~/store/companies/companies.store";
import { canSeeSalaryCosts as resolveSalaryCostsAccess } from "~/utils/helpers/salaryCostsAccess";

/**
 * Single gate for every surface exposing a loaded hourly cost (coût horaire chargé): the session
 * Coûts tab, the session Admin recap, the registration detail and the user's "Salaire horaire".
 *
 * It only ever answers false for a group admin whose company turned `groupAdminSalaryCostsVisible`
 * off — every other role keeps whatever gate its own surface already applies, so compose the two
 * (`isAdmin && canSeeSalaryCosts`) rather than replacing them. Reads companyInfos, fetched at
 * login and $reset on Log-As, so a failed refresh fails closed instead of leaking salaries.
 */
export function useSalaryCostsAccess() {
  const authStore = useAuthStore();
  const companiesStore = useCompaniesStore();

  const canSeeSalaryCosts = computed<boolean>(() =>
    resolveSalaryCostsAccess({
      isCompanyAdmin: authStore.isCompanyAdmin,
      isGroupAdmin: authStore.isGroupAdmin,
      groupAdminSalaryCostsVisible: companiesStore.companyInfos?.groupAdminSalaryCostsVisible,
    }),
  );

  return { canSeeSalaryCosts };
}
